export default __webpack_public_path__ + "static/media/wisdom_of_crowds_simulation.6bedb863.gif";